export default {
  PARTNER: 'PARTNER',
  INDIVIDUAL: 'INDIVIDUAL',
  BUSINESS: 'BUSINESS',
};
